import { render, staticRenderFns } from "./ShareWork.vue?vue&type=template&id=446551ac"
import script from "./ShareWork.vue?vue&type=script&lang=js"
export * from "./ShareWork.vue?vue&type=script&lang=js"
import style0 from "./ShareWork.vue?vue&type=style&index=0&id=446551ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports